import React, { ButtonHTMLAttributes, ReactNode } from "react";
import cn from "classnames";
import styles from "./ButtonIcon.module.scss";
import { Tooltip } from "antd";
import { Icon } from "../icon/Icon";
import { LoadingContainer } from "~/containers/loading-сontainer";

export type ButtonIconVariant =
  | "default"
  | "gray"
  | "success"
  | "error"
  | "warning";

export interface ButtonIconProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
  iconName?: string;
  /** Иконка: можно передать <Icon name="..." /> или любую React-ноду (например <DeleteOutlined />) */
  icon?: ReactNode;
  /** variant управляет подсветкой фона */
  variant?: ButtonIconVariant;
  /** размер иконки */
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "auto";
  /** тултип при наведении */
  tooltip?: string;
  /** класс для корня */
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  "aria-label"?: string;
  /** состояние загрузки */
  loading?: boolean;
}

export const ButtonIcon: React.FC<ButtonIconProps> = ({
  iconName,
  icon,
  variant = "default",
  size = "sm",
  tooltip,
  className,
  disabled,
  loading = false,
  onClick,
  ...rest
}) => {
  const isDisabled = disabled || loading;

  const rootClass = cn(
    styles.button,
    {
      [styles.success]: variant === "success",
      [styles.error]: variant === "error",
      [styles.warning]: variant === "warning",
      [styles.gray]: variant === "gray",
      [styles.default]: variant === "default",
      [styles.disabled]: isDisabled,
      [styles.loading]: loading,
    },
    className
  );

  const content = (
    <button
      type="button"
      className={rootClass}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      {...rest}
    >
      <LoadingContainer isLoading={loading}>
        {icon ? (
          icon
        ) : iconName ? (
          <Icon name={iconName} size={size} className={styles.icon} />
        ) : null}
      </LoadingContainer>
    </button>
  );

  return tooltip ? (
    <Tooltip
      placement="top"
      title={tooltip}
      arrow={false}
      overlayInnerStyle={{
        backgroundColor: "#8C8E94",
        padding: 20,
        fontSize: 14,
        fontFamily: "Onest",
        lineHeight: "24px",
      }}
    >
      {content}
    </Tooltip>
  ) : content;
};